<template>
	<div>
		<!--    搜索部分-->
		<el-form :inline="true" :model="enquiryForm" class="demo-form-inline" label-width="80px">
			<el-form-item label="激活时间" style="width: 590px">
				<el-date-picker v-model="enquiryForm.activate_time" type="datetimerange" range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
					@change="pickerChange">
				</el-date-picker>
			</el-form-item>
		</el-form>
    <div style="margin-bottom: 10px">
      <el-button size="medium" type="primary" style="font-size: 12px;" @click="handleSearch(enquiryForm)">查询</el-button>
      <el-button size="medium"  style="font-size: 12px;" @click="Reset(enquiryForm)">重置</el-button>
      <el-button size="medium" type="warning" style="font-size: 12px;" @click="exportData">导出</el-button>
      <el-button size="medium"  type="danger" style="font-size: 12px;" @click="printEvent()"> 打印</el-button>
    </div>
<!-- //打印 -->
			<prints ref="prints" :tableData="tableData" :tableTh="tableTh" :tableTd="tableTd" v-show="false"></prints>
		<!--    表格部分-->
		<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
			v-loading="loading" border id="tableDataId" size="mini">
			<el-table-column header-align="center" align="center" prop="id" label="ID" sortable></el-table-column>
			<el-table-column header-align="center" align="center" prop="user_name" label="用户名称"></el-table-column>
			<el-table-column header-align="center" align="center" prop="user_account" label="用户手机号"></el-table-column>
			<el-table-column header-align="center" align="center" prop="merch_name" label="产品名称"></el-table-column>
			<el-table-column header-align="center" align="center" prop="order_amount" label="支付总金额"></el-table-column>
			<el-table-column header-align="center" align="center" prop="pay_coin" label="积分交易总数"></el-table-column>
			<el-table-column header-align="center" align="center" prop="stock" label="商品交易数量"></el-table-column>
			<el-table-column header-align="center" align="center" prop="order_number" label="订单总数量"></el-table-column>
		</el-table>

		<!-- 分页部分 -->
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20,50,100,200,500,1000]" :page-size="page_size" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right">
		</el-pagination>
	</div>
</template>

<script>
	import {
		export_json_to_excel
	} from "@/excel/Export2Excel";
import prints from '@/components/print.vue'
	export default {
		name: "orderCollection", //订单收款统计页面
		components:{
			prints
		},
		data() {
			return {
				// 主页面部分
				loading: true, //列表loadding
				page_size: 20, //条数
				total: 0, //总数
				tableData: [], //表格数据
				enquiryForm: {
					page_size: 20,
					page: 1,
				},
				//打印
				tableTh:null,
				tableTd:null,
			}
		},
		created() {
			this.getData(this.enquiryForm)
			this.tableTh = ['ID', '用户名称', '用户账号', '产品名称', '产品名称', '积分交易总数', '商品交易数量', '订单总数量'];
			this.tableTd = ['id', 'user_name', 'user_account', 'merch_name', 'order_amount', 'pay_coin',
				'stock', 'order_number'
			];
			this.$nextTick(()=>{
				this.$refs.prints.prints();
			})
		},
		methods: {
			//打印
			printEvent(){
				this.$nextTick(()=>{
					this.$refs.prints.prints();
					this.$refs.prints.print();
				})
			},
			handleDefaultTime() { //默认获取三十天
				let date = this.$moment().endOf('day').format('x');
				this.enquiryForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
				this.enquiryForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 + 1).format(
					"YYYY-MM-DD HH:mm:ss");
				this.enquiryForm.activate_time = [this.enquiryForm.start_time, this.enquiryForm.end_time];
			},
			pickerChange(DateArr) { //时间选择器
				this.enquiryForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
				this.enquiryForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
			},
			printDemo() {

			},
			// 主页面部分
			//搜索
			handleSearch(searchForm) {
				searchForm.page = 1;
				this.getData(searchForm);
			},
			//重置
			Reset(searchForm) {
				searchForm.page = 1;
				searchForm.activate_time = "";
				this.enquiryForm.end_time = '';
				this.enquiryForm.start_time = "";
				this.getData(searchForm);
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.enquiryForm.page = page;
				this.getData(this.enquiryForm);
			},
			handleSizeChange(limit) { //条数
				this.enquiryForm.page_size = limit;
				this.enquiryForm.page = 1;
				this.getData(this.enquiryForm);
			},
			//获取数据
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("/api/order/orderPriceList?page=" + params.page, params, res => {
					if (res.status == 200) {
						let tableData = res.data;
						this.total = tableData.total; //总数
						this.tableData = tableData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
			// 导出
			exportData() {
				let th = ['ID', '用户名称', '用户账号', '产品名称', '产品名称', '积分交易总数', '商品交易数量', '订单总数量'];
				let excelData = ['id', 'user_name', 'user_account', 'merch_name', 'order_amount', 'pay_coin',
					'stock', 'order_number'
				];
				let data = this.formatJson(excelData, this.tableData);
				let defaultTitle = '导出文件';
				export_json_to_excel(th, data, defaultTitle)
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => v[j]))
			},
			// 表单部分

		}
	}
</script>

<style scoped>
	/deep/ .el-form-item__content .el-input-group {
		vertical-align: middle !important;
	}
  /deep/ .el-date-editor--datetimerange{
    height: 36px;
    width: 510px;
  }
	.code {
		cursor: pointer;
	}

	.code:hover {
		color: blue;
		text-decoration: underline;
	}
</style>
